class ProductMedia extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            slider: '[data-slider]',
            mediaItem: '[data-media-id]',
            modalOpeners: '[data-modal-opener-id]',
            zoomContainer: '[data-zoom-container]',
            zoomImages: '[data-pswp-image]',
            btnXr: '[data-shopify-xr]',
            withThumbs: '[data-with-thumbs]',
        };
        this.selectedMediaIndex =
            Number(
                this.querySelector(this.selectors.slider).querySelector(
                    '[data-selected]'
                )?.dataset.index
            ) || 0;

        const swiperOptions = JSON.parse(
            this.querySelector(this.selectors.slider).getAttribute(
                'data-swiper-options'
            )
        );

        this.settings = {
            sliderElement: this.querySelector(this.selectors.slider),
            sliderInstance: null,
            options: {
                initialSlide: this.selectedMediaIndex,
                navigation: {
                    prevEl: this.querySelector('.swiper-button--prev'),
                    nextEl: this.querySelector('.swiper-button--next')
                },

                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar'
                },

                spaceBetween: 2,
                watchOverflow: true,
                autoHeight: this.dataset.autoHeight === 'true',
                slidesPerView: 1,
                on: {
                    afterInit: swiper => {
                        // if firstSlide has video, play it
                        const firstSlide = swiper.slides[0];
                        const firstSlideVideo = firstSlide.querySelector('video');
                        if (firstSlideVideo) {
                            firstSlideVideo.play();
                        }

                        // if firstSlide has youtube, play it
                        const firstSlideYoutube =
                            firstSlide.querySelector('.js-youtube');
                        if (firstSlideYoutube) {
                            this.playYoutubeVideo(firstSlideYoutube);
                        }

                        // if firstSlide has vimeo, play it
                        const firstSlideVimeo =
                            firstSlide.querySelector('.js-vimeo');
                        if (firstSlideVimeo) {
                            this.playVimeoVideo(firstSlideVimeo);
                        }
                    },
                    slideChangeTransitionEnd: swiper => {
                        this.setActiveModalOpener(swiper);
                    },
                    transitionStart: swiper => {
                        const videos = swiper.el.querySelectorAll('video');
                        Array.from(videos).forEach(video => {
                            video.pause();
                        });
                    },
                    transitionEnd: swiper => {
                        let slideIndex = swiper.activeIndex;
                        const swiperCardWidth = swiper.slides[0].offsetWidth;
                        slideIndex = Math.abs(
                            Math.floor(swiper.translate / [swiperCardWidth])
                        );
                        if (slideIndex !== 0) {
                            slideIndex = slideIndex - 1;
                        } else {
                            slideIndex = swiper.slides.length - 1; // Vuelve al último slide al llegar al final
                        }
                        const activeSlide = Array.from(swiper.slides).find(
                            sliderSlide =>
                                sliderSlide.classList.contains('swiper-slide-active')
                        );

                        // play or pause videos in active and next slides
                        const activeSlideVideo =
                            activeSlide.querySelector('video');
                        const nextSlideVideo =
                            activeSlide.nextElementSibling?.querySelector('video');

                        const playVideo = video => {
                            if (video && video.paused) {
                                video.play();
                            } else if (video) {
                                video.pause();
                            }
                        };

                        playVideo(activeSlideVideo);
                        playVideo(nextSlideVideo);

                        const activeSlideYoutube =
                            activeSlide.querySelector('.js-youtube');
                        if (activeSlideYoutube) {
                            this.playYoutubeVideo(activeSlideYoutube);
                        }

                        const activeSlideVimeo =
                            activeSlide.querySelector('.js-vimeo');
                        if (activeSlideVimeo) {
                            this.playVimeoVideo(activeSlideVimeo);
                        }
                    }
                }
            }
        };
    }

    playYoutubeVideo(element) {
        element.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
    }

    playVimeoVideo(element) {
        element.contentWindow.postMessage('{"method":"play"}', '*');
    }

    connectedCallback() {
        this.init();
    }

    init() {
        const [zoomContainerWidth, zoomContainerHeight, closeIcon] = [
            this.offsetWidth,
            this.offsetHeight,
            this.querySelector('[data-close-icon')
        ];

        function isPhone() {
            return window.innerWidth < 750;
        }

        const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
            gallery: this.selectors.zoomImages,
            appendToEl: this.querySelector(this.selectors.zoomContainer),

            initialZoomLevel: (zoomLevelObject) => {
                if (isPhone()) {
                    return zoomLevelObject.vFill;
                } else {
                    return zoomLevelObject.fit;
                }
            },
            secondaryZoomLevel: (zoomLevelObject) => {
                if (isPhone()) {
                    return zoomLevelObject.fit;
                } else {
                    return 1;
                }
            },
            maxZoomLevel: 2,
            getViewportSizeFn: function (options, pswp) {
                return {
                    x: zoomContainerWidth,
                    y: zoomContainerHeight
                };
            },
            pswpModule: PhotoSwipe
        });
        photoSwipeLightboxInstance.addFilter(
            'uiElement',
            (element, data) => {
                if (data.name === 'close') {
                    element.innerHTML = closeIcon.innerHTML;
                }
                return element;
            }
        );

        photoSwipeLightboxInstance.init();
        if (!this.settings.sliderElement) return;

        this.settings.sliderInstance = new Swiper(
            this.settings.sliderElement,
            this.settings.options
        );
    }

    setActiveMedia(id) {
        const mediaFound = Array.from(
            this.querySelectorAll(this.selectors.mediaItem)
        ).find(media => Number(media.dataset.mediaId) === id);
        if (!mediaFound) return;
        this.settings.sliderInstance.slideTo(
            Number(mediaFound.dataset.index)
        );

        // const thumbs = this.settings.sliderInstance.thumbs.swiper;
        // thumbs.slideTo(Number(mediaFound.dataset.index));
    }

    setActiveModalOpener(swiper) {
        const activeSlide = swiper.slides.filter(sliderSlide =>
            sliderSlide.classList.contains('swiper-slide-active')
        )[0];
        if (!activeSlide) return;
        const activeMediaId = activeSlide.dataset.mediaId;
        this.querySelector(
            `${this.selectors.modalOpeners}.is-active`
        )?.classList.remove('is-active');
        this.querySelector(
            `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
        )?.parentElement.classList.add('is-active');

        const isModel = activeSlide.dataset.mediaType === 'model';

        if (!isModel) return;

        const btnXr = this.querySelector(this.selectors.btnXr);
        btnXr.dataset.shopifyModel3dId = activeMediaId;
    }
}

customElements.define('product-media', ProductMedia);
